/**
 * Panel ekranı ↔ adres çubuğu eşlemesi.
 *
 * ================================================================
 * NEDEN VAR — 05.10.2026 (Emre)
 * ================================================================
 * Panelin yönlendiricisi yoktu: hangi ekranın açık olduğu yalnızca
 * bellekteki `aktif` değerindeydi ve adres hep `/` kalıyordu. Sonucu:
 * sayfa yenilenince kullanıcı "Bugün"e düşüyordu, tarayıcının geri
 * tuşu panelden çıkarıyordu, bir ekranı bağlantıyla paylaşmak mümkün
 * değildi.
 *
 * Kütüphane (react-router) EKLENMEDİ: ekranlar zaten tek bir anahtarla
 * seçiliyor ve izin kontrolü `MENU` üzerinden yapılıyor. Yönlendirici
 * eklemek ikinci bir "hangi ekran açık" gerçeği doğururdu; burada adres
 * yalnızca o anahtarın aynası.
 *
 * ÖĞRENCİ KİMLİĞİ ADRESE YAZILMIYOR — bilerek. Adres tarayıcı geçmişine
 * ve paylaşılan bağlantılara giriyor; seçili öğrenciyi oraya koymak
 * "kimin kime baktığı" bilgisini denetim kaydının dışında ikinci bir
 * yerde biriktirirdi (F-STV-16'daki gerekçenin aynısı). Öğrenci gerektiren
 * bir ekran adresle açılınca öğrenci seçici çıkıyor.
 *
 * Adres GÜVENLİK sınırı değil: elle `/finans` yazan kullanıcı yetkisi
 * yoksa 403 ekranını görür, veriyi sunucu zaten vermez (CLAUDE.md kural 1).
 */

/** Ana ekran kök adreste duruyor; `/bugun` diye ikinci bir adı olmasın. */
export const ANA_EKRAN = "bugun";

export function ekranYolu(anahtar: string): string {
  return anahtar === ANA_EKRAN ? "/" : `/${anahtar}`;
}

/**
 * Adresten ekran anahtarı. Tanınmayan adres `null` — çağıran onu 404
 * sayar. Sondaki `/` yok sayılıyor (`/finans/` ile `/finans` aynı ekran),
 * alt yol kabul edilmiyor (`/finans/x` bir ekran değil; sessizce
 * `/finans`e düşürmek yanlış bağlantıyı çalışıyormuş gibi gösterirdi).
 */
export function yoldanEkran(yol: string, gecerli: ReadonlySet<string>): string | null {
  const temiz = yol.replace(/\/+$/, "") || "/";
  if (temiz === "/") return ANA_EKRAN;
  const ad = temiz.slice(1);
  if (ad === ANA_EKRAN) return null;
  return gecerli.has(ad) ? ad : null;
}
